module.exports = __webpack_public_path__ + "static/media/host-landing-bg2.77758ff1.svg";